export const navigateToAuth = ({ isAdmin }) => {
  const path = isAdmin
    ? "/authentication/admin/login"
    : "/authentication/login";
  window.location.href = path;
};
